export default [
  {
    path: '/about',
    name: 'About',
    component: () => import('./index.vue')
  }
]
